module.exports = __webpack_public_path__ + "assets/98dc8494e916b01b34d3aa74499754e1.png";